<div class="admin-concept-concepts">
  @if (conceptsContainer.loadingConcepts) {
    <div class="admin-concept-concepts__progress-spinner">
      <mat-spinner color="accent" diameter="22"></mat-spinner>
      <span class="admin-concept-concepts__progress-spinner-text">
        {{ 'TRANS__LOGIN__PROCESSING' | translate }}
      </span>
    </div>
  }

  @else if (!conceptsContainer.loadingConcepts && conceptsContainer.conceptDataSource.data) {
    <div class="admin-concept-concepts__content">
      <div class="admin-content-top admin-concept-concepts__title-container">
        @if (conceptsContainer.concepts) {
          <h5>
            <span>
              {{ menuTitle | translate}}
            </span>
            ({{selected}}{{conceptsContainer.concepts.hits}})
          </h5>
        }

        <app-admin-action-list-menu
          [conceptsContainer]="conceptsContainer"
          [selectedItemLength]="conceptsContainer.selected.length"
        ></app-admin-action-list-menu>
        <app-admin-list-filter-menu
          [conceptsContainer]="conceptsContainer"
          (filterChange)="onSearchParamChange()"
        ></app-admin-list-filter-menu>
        <app-admin-list-query
          class="admin-concept-concepts__search-query"
          [conceptsContainer]="conceptsContainer"
          [hideIcon]="true"
          [setFocus]="false"
          (queryChange)="onSearchParamChange()"
        ></app-admin-list-query>
        <app-admin-list-settings [conceptsContainer]="conceptsContainer"></app-admin-list-settings>
      </div>
      @if (conceptsContainer) {
        <app-admin-list-table
          [conceptsContainer]="conceptsContainer"
          [reloadConcepts]="conceptsContainer.reload"
        ></app-admin-list-table>
      }
    </div>
  }


</div>

